import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

type Props = {
	permission: string;
	homePath: string;
};

export const ForbiddenPage = ({ permission, homePath }: Props) => {
	const { pathname } = useLocation();

	return (
		<Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
			<Paper elevation={2} sx={{ maxWidth: 520, width: "100%", p: 4 }}>
				<Box sx={{ textAlign: "center" }}>
					<LockOutlinedIcon sx={{ fontSize: 56, color: "text.disabled" }} />
					<Typography variant="h6" sx={{ mt: 1 }}>
						You do not have access to this screen
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
						Your profile is missing the permission below. Ask a supervisor to
						add it, quoting it exactly as written.
					</Typography>
				</Box>

				<Stack spacing={2} sx={{ mt: 3 }}>
					<Box>
						<Typography variant="caption" color="text.secondary">
							Screen
						</Typography>
						<Typography variant="body2">{pathname}</Typography>
					</Box>
					<Box>
						<Typography variant="caption" color="text.secondary">
							Missing permission
						</Typography>
						<Typography
							variant="body2"
							sx={{ fontFamily: "monospace", wordBreak: "break-all" }}
						>
							{permission}
						</Typography>
					</Box>
				</Stack>

				<Box sx={{ textAlign: "center", mt: 3 }}>
					<Button component={Link} to={homePath} variant="contained">
						Go to home
					</Button>
				</Box>
			</Paper>
		</Box>
	);
};
